import React from 'react';
import styled, { css } from 'styled-components';
import Text, { TextSize, FontWeight } from '../atoms/text';
import TextContainer from '../atoms/text-container';

interface OnlineTagProps {
  isOnline: boolean;
}

const StatusWrapper = styled.div<{ $isOnline: boolean }>`
  color: ${({ $isOnline }) => ($isOnline ? '#0f8f63' : '#7b8aa3')};
  background-color: ${({ $isOnline }) => ($isOnline ? 'rgba(18, 165, 113, 0.1)' : 'rgba(101, 116, 141, 0.07)')};
  border: 1px solid ${({ $isOnline }) => ($isOnline ? 'rgba(18, 165, 113, 0.2)' : '#e0e8f5')};
  border-radius: 6px;
  display: inline-flex;
  align-items: center;
  margin-left: 10px;
`;

export const OnlineTag: React.FC<OnlineTagProps> = ({ isOnline }) => {
  return (
    <StatusWrapper $isOnline={isOnline}>
      <Text 
        size={TextSize.XS} 
        weight={FontWeight.REGULAR}
        color="inherit"
      >
        <TextContainer text={isOnline ? 'Online' : 'Offline'} />
      </Text>
    </StatusWrapper>
  );
};

export default OnlineTag;
